import { render } from "./TuazonDialog.vue?vue&type=template&id=2e06e12c&scoped=true"
import script from "./TuazonDialog.vue?vue&type=script&lang=js"
export * from "./TuazonDialog.vue?vue&type=script&lang=js"

import "./TuazonDialog.vue?vue&type=style&index=0&id=2e06e12c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e06e12c"]])

export default __exports__